/*$(document).ready(function(){
    
  // Build a Box small print
  
  $("#bxp-bldr-price_total").append("<div class='bbsmallprint discountsmallprint'>Discount automatically applied at check out.</div> ");
  $("#bxp-bldr-bottom-wizard").append("<div class='bbsmallprint'>* Once you click <b>COMPLETE ORDER</b> and go to the cart, you will not be able to modify your bundle.</div> ");

  $(".bxp-details-price").text(function(index, text) { 
    return text.replace(':', ' '); 
  });

  $("body").on('DOMSubtreeModified', "#bxp-bldr-total_value", function() {
      setTimeout(function(){  
        $(".bxp-details-price").text(function(index, text) { 
          text= text.replace(':', ' ');
          return text; 
        });
        
      }, 500);
  });

  // $("body").on('DOMSubtreeModified', ".bxp-bldr-item", function() {
  //  setTimeout(function(){  
  //    $(".bxp-bldr-item strong").text(function(index, text) { 
  //    return text.replace(' - 1 box (16 tea bags)', ' '); 
  //    });
  //  }, 500);
  // });

  
  var countblocks=0;

  function checkprodblocks(){
      jQuery('.bxp-bldr-item > label > strong').each(function() { 
          let text = jQuery(this).html();
          jQuery(this).html(text.replace('&lt;sup&gt;®&lt;/sup&gt;','®').replace('&lt;sup&gt;™&lt;/sup&gt;','™'));        
      });
  }

  setInterval(function(){
      countblocks++;
      if(countblocks<10){
        checkprodblocks();
      }
  }, 500);

  

});*/




$(document).ready(function(){
    
  // Build a Box small print

  setTimeout(function(){  

    $(".rt-r-gap-4.justify-evenly button.rt-BaseButton").prop(":", "").fadeTo( "slow", 1 );

      
      $(".rt-r-gap-4.justify-evenly button.rt-BaseButton").html(function () {
          return $(this).html().replace(" $", "<span>$").replace(":", " ").replace("€", "<span>€"); 
      });

      $("span.rt-Text.rt-r-size-2.rt-r-weight-medium.bb-details__text-content--custom-color").html(function () {
          return $(this).html().replace(":", " ").replace("$", "<span>$").replace("€", "<span>€"); 
      });

    $("span.rt-Text.rt-r-size-2.rt-r-weight-medium.bb-details__text-content--custom-color").html(function () {
          return $(this).html().replace(":", " ").replace("$", "<span>$").replace("€", "<span>€"); 
      });

    $("span.rt-Text.rt-r-size-2.rt-r-weight-bold.rt-r-ta-center.xs\:rt-r-ta-center.sm\:rt-r-ta-center").html(function () {
         return $(this).html().replace("<sup>", "").replace("</sup>", "");
    });

    $("button.rt-reset.rt-BaseButton.rt-r-size-2.rt-variant-solid.rt-high-contrast.rt-Button.bb-btn.bb-btn__primary--custom-color").html(function () {
          return $(this).html().replace(":", " "); 
      });
  
      $(".rt-Grid.rt-r-gtc-2.rt-r-gap-3").after("<div class='bbsmallprint discountsmallprint hide-on-mobile'>Discount automatically applied at check out.</div> ");
      $(".rt-r-fd-row").append("<div class='bbsmallprint hide-on-mobile'>* Once you click <b>COMPLETE ORDER</b> and go to the cart, you will not be able to modify your bundle.</div> ");
  
      $(".bxp-details-price").text(function(index, text) { 
        return text.replace(':', ' '); 
      });
    
  }, 5000);


  $("body").on('DOMSubtreeModified', ".bb-details__text-total--custom-color", function() {
      setTimeout(function(){  
       
      $("span.rt-Text.rt-r-size-2.rt-r-weight-medium.bb-details__text-content--custom-color").html(function () {
        //const found = $(this).html().match(/^(\$\d+.\d{2})$/);

        //put correct currency before release
        var price = $(this).html().substring($(this).html().indexOf("$"));
        
        if(price.indexOf("span")> -1){
          return; 
        } else {
          return $(this).html().replace(":", " ").replace("$", "<span>$").replace("€", "<span>€"); 
        }
      });

      $("button.rt-reset.rt-BaseButton.rt-r-size-2.rt-variant-solid.rt-high-contrast.rt-Button.bb-btn.bb-btn__primary--custom-color").html(function () {
          return $(this).html().replace(":", " "); 
      });

      }, 100);
  });

 /* keep price from bouncing into button when search is used */
  $(".rt-TextFieldInput").on("input", function() {
    $(".rt-r-gap-4.justify-evenly button.rt-BaseButton").html(function () {
        return $(this).html().replace(" $", "<span>$").replace(":", " ").replace("€", "<span>€"); 
    });
  });

  $("button.rt-reset.rt-SelectTrigger.rt-r-size-2.rt-variant-surface").on('change',function() {
     console.log("triggered");
     $(".rt-r-gap-4.justify-evenly button.rt-BaseButton").html(function () {
        return $(this).html().replace(" $", "<span>$").replace(":", " ").replace("€", "<span>€"); 
    });
  });
      
      
});



